import type { ReactNode } from 'react';
import { Table, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { SortDirection } from './useTableSort';

interface SortableThProps {
  children: ReactNode;
  direction?: SortDirection;
  onSort: () => void;
  ta?: 'right';
}

export function SortableTh({ children, direction, onSort, ta }: SortableThProps) {
  const { t } = useTranslation();
  return (
    <Table.Th ta={ta} aria-sort={direction ?? 'none'}>
      <UnstyledButton
        onClick={onSort}
        title={t(direction === 'ascending' ? 'common.sortDescending' : 'common.sortAscending')}
        style={{ display: 'flex', alignItems: 'center', justifyContent: ta === 'right' ? 'flex-end' : 'flex-start', gap: 6, width: '100%', font: 'inherit', letterSpacing: 'inherit', textTransform: 'inherit', color: 'inherit' }}
      >
        {children}
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" style={{ flexShrink: 0 }}>
          <path d={direction === 'ascending' ? 'm4 9 3-3 3 3' : direction === 'descending' ? 'm4 5 3 3 3-3' : 'm4 5 3-3 3 3 M4 9l3 3 3-3'} />
        </svg>
      </UnstyledButton>
    </Table.Th>
  );
}
